<template lang="pug">
.promos-header__user-mobile
  template(v-if="!isUserInProject")
    button.promos-header__user-mobile-button.promos-header__user-mobile-button--login(
      @click="login"
    ) {{ $t('common.login') }}
    button.promos-header__user-mobile-button.promos-header__user-mobile-button--register(
      @click="register"
    ) {{ $t('common.register') }}

  template(v-else)
    .promos-header__user-mobile-button.promos-header__user-mobile-button--name {{ getUserDisplayName }}
    button.promos-header__user-mobile-button.promos-header__user-mobile-button--logout(
      @click="logout"
    ) {{ $t('common.logout') }}
</template>

<script>
import NavigationUserMixin from "@static_promo_pages/common/mixins/NavigationUserMixin";

export default {
  name: "PromosHeaderUserMobile",
  mixins: [NavigationUserMixin],
};
</script>

<style lang="scss" scoped>
@import "../../styles/blocks/header-user-mobile";
</style>